import type { ReactElement, SyntheticEvent } from "react"
import React from "react"
import BreakpointVisibilityOrg from "@onestore/hel/dist/components/organisms/BreakpointVisibilityOrg"
import HorizontalScrollItemsOrg from "@onestore/hel/dist/components/organisms/HorizontalScrollItemsOrg"
import { mobileSlideWidthSpace } from "@onestore/hel/dist/components/organisms/ProductCardsSliderOrg"
import { ProductCardsSliderOrgContextProvider } from "@onestore/hel/dist/components/organisms/ProductCardsSliderOrg/ProductCardsSliderOrgContext"
import ProductCardsTemplateBase from "@onestore/hel/dist/components/templates/ProductCardsTemplate"
import type { ProductCardItem } from "@gatsby-plugin-marketplace/fragments/marketplaceProductCard"
import ProductCardMol from "~/components/ProductCardMol"
import useProductCards from "~/hooks/useProductCards"

interface ProductCardsTemplateProps {
  link?: {
    text: string
    href: string
    title: string
    onClick: { (event: SyntheticEvent): void }
  }
  heading?: {
    caption?: string
    title: string
  }
  products: ProductCardItem[]
}

export default function ProductCardsTemplate({
  link,
  heading,
  products,
}: ProductCardsTemplateProps): ReactElement<ProductCardsTemplateProps> {
  const cards = useProductCards(products)

  return (
    <>
      <BreakpointVisibilityOrg from="small" to="large">
        <ProductCardsSliderOrgContextProvider>
          <HorizontalScrollItemsOrg
            gutterSpace={2}
            bottomSpace={3}
            itemWidthSpace={mobileSlideWidthSpace}
          >
            {products.map((product) => (
              <ProductCardMol key={product.flatData.name} product={product} />
            ))}
          </HorizontalScrollItemsOrg>
        </ProductCardsSliderOrgContextProvider>
      </BreakpointVisibilityOrg>

      <BreakpointVisibilityOrg from="large">
        <ProductCardsTemplateBase link={link} heading={heading} cards={cards} />
      </BreakpointVisibilityOrg>
    </>
  )
}
